import { isNumber, isFunction } from '@motionone/utils';
import { getEasingFunction } from '@motionone/animation';
function stagger() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.1;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$start = _ref.start,
    start = _ref$start === void 0 ? 0 : _ref$start,
    _ref$from = _ref.from,
    from = _ref$from === void 0 ? 0 : _ref$from,
    easing = _ref.easing;
  return function (i, total) {
    var fromIndex = isNumber(from) ? from : getFromIndex(from, total);
    var distance = Math.abs(fromIndex - i);
    var delay = duration * distance;
    if (easing) {
      var maxDelay = total * duration;
      var easingFunction = getEasingFunction(easing);
      delay = easingFunction(delay / maxDelay) * maxDelay;
    }
    return start + delay;
  };
}
function getFromIndex(from, total) {
  if (from === "first") {
    return 0;
  } else {
    var lastIndex = total - 1;
    return from === "last" ? lastIndex : lastIndex / 2;
  }
}
function resolveOption(option, i, total) {
  return isFunction(option) ? option(i, total) : option;
}
export { getFromIndex, resolveOption, stagger };